module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/zonaprop_mobile.e20dd7cc.svg";